import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const TURLER = [
  { value: 'yonetim_kurulu', label: 'Yönetim Kurulu' },
  { value: 'mudurler',       label: 'Müdürler Kurulu' },
  { value: 'daire',          label: 'Daire Toplantısı' },
  { value: 'proje',          label: 'Proje Toplantısı' },
  { value: 'diger',          label: 'Diğer' },
];

const emptyForm = { baslik: '', tarih: '', yer: '', tur: 'diger', notlar: '' };

export default function ToplantıListesi() {
  const nav = useNavigate();
  const [toplantilar, setToplantilar] = useState<any[]>([]);
  const [filtre,  setFiltre]  = useState({ tur: '', yil: String(new Date().getFullYear()) });
  const [modal,   setModal]   = useState(false);
  const [secili,  setSecili]  = useState<any>(null);
  const [form,    setForm]    = useState<any>({ ...emptyForm });
  const [hata,    setHata]    = useState('');
  const [yuk,     setYuk]     = useState(false);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p = new URLSearchParams();
    if (filtre.tur) p.set('tur', filtre.tur);
    if (filtre.yil) p.set('yil', filtre.yil);
    fetch(`${API}/api/is-takip/toplantilar?${p}`, { headers: hdr() })
      .then(r => r.json()).then(setToplantilar).catch(() => setToplantilar([]));
  };

  const yeniAc = () => { setSecili(null); setForm({ ...emptyForm }); setHata(''); setModal(true); };
  const duzenleAc = (t: any) => {
    setSecili(t);
    setForm({
      baslik: t.baslik, tarih: t.tarih ? t.tarih.slice(0, 16) : '',
      yer: t.yer || '', tur: t.tur || 'diger', notlar: t.notlar || '',
    });
    setHata(''); setModal(true);
  };

  const kaydet = async () => {
    if (!form.baslik.trim()) { setHata('Başlık zorunludur'); return; }
    if (!form.tarih)         { setHata('Tarih zorunludur');  return; }
    setHata(''); setYuk(true);
    try {
      const url    = secili ? `${API}/api/is-takip/toplantilar/${secili.id}` : `${API}/api/is-takip/toplantilar`;
      const method = secili ? 'PUT' : 'POST';
      const res = await fetch(url, { method, headers: { ...hdr(), 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
      if (!res.ok) throw new Error();
      setModal(false); yukle();
      // Yeni toplantıysa detaya git
      if (!secili) {
        const data = await res.json();
        nav(`/toplanti/${data.id}`);
      }
    } catch { setHata('Kayıt hatası'); }
    finally { setYuk(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu toplantı silinsin mi?')) return;
    await fetch(`${API}/api/is-takip/toplantilar/${id}`, { method: 'DELETE', headers: hdr() });
    yukle();
  };

  const inp = (f: string) => (e: any) => setForm((v: any) => ({ ...v, [f]: e.target.value }));
  const yillar = Array.from({ length: 5 }, (_, i) => String(new Date().getFullYear() - i));

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 18, color: '#1a3c5e' }}>🤝 Toplantılar</h2>
        <button onClick={yeniAc} style={{ background: '#1a5276', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', cursor: 'pointer', fontSize: 13 }}>+ Yeni Toplantı</button>
      </div>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
        <select value={filtre.tur} onChange={e => setFiltre(f => ({ ...f, tur: e.target.value }))}
          style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12 }}>
          <option value="">Tüm Türler</option>
          {TURLER.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
        <select value={filtre.yil} onChange={e => setFiltre(f => ({ ...f, yil: e.target.value }))}
          style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12 }}>
          {yillar.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      {/* Toplantı Kartları */}
      {toplantilar.length === 0 && (
        <div style={{ textAlign: 'center', padding: 40, color: '#bbb' }}>Toplantı kaydı bulunamadı</div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {toplantilar.map(t => (
          <div key={t.id} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px',
            boxShadow: '0 1px 4px rgba(0,0,0,.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => nav(`/toplanti/${t.id}`)}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e', marginBottom: 4 }}>{t.baslik}</div>
              <div style={{ display: 'flex', gap: 14, fontSize: 11, color: '#888', flexWrap: 'wrap' }}>
                <span>📅 {t.tarih?.slice(0, 16)?.replace('T', ' ')}</span>
                {t.yer && <span>📍 {t.yer}</span>}
                <span style={{ background: '#f0f4ff', color: '#1a5276', padding: '1px 7px', borderRadius: 8 }}>
                  {TURLER.find(x => x.value === t.tur)?.label || t.tur}
                </span>
                {t.karar_sayisi > 0 && <span>📋 {t.karar_sayisi} karar</span>}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginLeft: 16 }}>
              <button onClick={() => nav(`/toplanti/${t.id}`)}
                style={{ background: 'none', border: '1px solid #1a5276', color: '#1a5276', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>Detay</button>
              <button onClick={() => duzenleAc(t)}
                style={{ background: 'none', border: '1px solid #ddd', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>Düzenle</button>
              <button onClick={() => sil(t.id)}
                style={{ background: 'none', border: '1px solid #fcc', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, color: '#e74c3c' }}>Sil</button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 480, boxShadow: '0 8px 32px rgba(0,0,0,.2)' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 16 }}>{secili ? 'Toplantı Düzenle' : 'Yeni Toplantı'}</h3>

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Başlık *</label>
            <input value={form.baslik} onChange={inp('baslik')}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box', fontSize: 13 }} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Tarih & Saat *</label>
                <input type="datetime-local" value={form.tarih} onChange={inp('tarih')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Tür</label>
                <select value={form.tur} onChange={inp('tur')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  {TURLER.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
            </div>

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Yer / Platform</label>
            <input value={form.yer} onChange={inp('yer')} placeholder="Toplantı odası, Teams, vb."
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box', fontSize: 13 }} />

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Notlar</label>
            <textarea value={form.notlar} onChange={inp('notlar')} rows={3}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 16, boxSizing: 'border-box', fontSize: 13, resize: 'vertical' }} />

            {hata && <div style={{ color: '#e74c3c', fontSize: 12, marginBottom: 10 }}>{hata}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(false)} style={{ padding: '7px 18px', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer', fontSize: 13 }}>İptal</button>
              <button onClick={kaydet} disabled={yuk}
                style={{ padding: '7px 18px', borderRadius: 6, background: '#1a5276', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, opacity: yuk ? .6 : 1 }}>
                {yuk ? 'Kaydediliyor...' : secili ? 'Güncelle' : 'Oluştur ve Devam'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
